import { Component, HostBinding, OnInit } from '@angular/core';

@Component({
    selector: 'app-pdf-editable',
    templateUrl: './pdf-editable.component.html',
    styleUrls: ['./pdf-editable.component.scss']
})
export class PdfEditableComponent implements OnInit
{
    @HostBinding('class') classes = 'bg mat-typography';

    constructor() { }

    ngOnInit(): void
    {
    }
}
